import mutedTemplate from './muted.tpl.html';
import mutedThenSentTemplate from './mutedThenSent.tpl.html';

import { ETSAlertService } from './ETSAlertService';
import { getAlertAggregation } from './getAlertAggregation';
import { getAlertList } from './getAlertList';
import { applyAlertListState } from './applyAlertListState';

angular
    .module('signalview.alertsOverview', [
        'sfx.filterControls',
        'sfx.ui',
        'signalview.urlOverrides',
        'signalboost',
    ])

    .constant('severities', ['Critical', 'Major', 'Minor', 'Warning', 'Info'])

    .directive('muted', [
        'alertTypeService',
        function (alertTypeService) {
            return {
                replace: true,
                scope: {
                    is: '@?',
                    detectorId: '@?',
                    hasDetectorMutingRule: '<?',
                },
                restrict: 'E',
                templateUrl: mutedTemplate,
                link: function ($scope) {
                    function updateTooltip() {
                        const stateChange = alertTypeService
                            .getDisplayFor($scope.is || 'anomalous')
                            .toLowerCase();
                        $scope.tooltipText = `This alert was ${stateChange} while a muting rule was active. No notifications were sent.`;
                        $scope.detectorLink = null;

                        if ($scope.detectorId && $scope.hasDetectorMutingRule) {
                            $scope.detectorLink = '#/muting?detectorId=' + $scope.detectorId;
                            $scope.tooltipText += ' Click to view muting rules for this detector.';
                        } else if ($scope.detectorId) {
                            $scope.tooltipText +=
                                ' Muting was applied by a property-based muting rule or the muting rule on the detector has expired.';
                        }
                    }

                    updateTooltip();
                    $scope.$watch('hasDetectorMutingRule', updateTooltip);
                },
            };
        },
    ])

    .directive('mutedThenSent', [
        function () {
            return {
                replace: true,
                restrict: 'E',
                templateUrl: mutedThenSentTemplate,
            };
        },
    ])

    .filter('thousandSuffix', [
        'valueFormatter',
        function (valueFormatter) {
            /**
             * Used to convert long number with many digits to a short form (with rounding of course)
             */
            return function (input) {
                return valueFormatter.formatValue(input, 3);
            };
        },
    ])

    .service('getAlertAggregation', getAlertAggregation)
    .service('getAlertList', getAlertList)
    .service('ETSAlertService', ETSAlertService)
    .service('applyAlertListState', applyAlertListState);
